import React from 'react';
import {
  AgnesCard,
  AgnesCardContent,
  AgnesPageHeader,
  AgnesTabs,
  AgnesTabsContent,
  AgnesTabsList,
  AgnesTabsTrigger,
} from '@agnes/ui';
import { ClipboardList } from 'lucide-react';
import { TabTabelaRubricas } from '@/pages/folha-pagamento/index/tab-tabela-rubricas/TabTabelaRubricas';
import { TabGraficos } from '@/pages/folha-pagamento/index/tab-graficos/TabGraficos';
import { TabRubricasAnaliseLote } from '@/pages/folha-pagamento/index/tab-analise-lote/TabRubricasAnaliseLote';
import { useLocation } from 'react-router-dom';

export default function PageRubricas() {
  const abaInicial = (useLocation().state as { aba?: string } | null)?.aba;
  const [tab, setTab] = React.useState(abaInicial ?? 'graficos');
  React.useState('13/01/2025 03:00:00');
  const [rubricaLoteRefresh] = React.useState(0);

  return (
    <>
      <AgnesPageHeader
        icon={<ClipboardList />}
        title="Rubricas"
        subtitle="Analise rubricas e gerencie as aplicações de recomendações"
        breadcrumbs={[
          { label: 'Home', href: '/home' },
          { label: 'Folha de Pagamento' },
          { label: 'Rubricas' },
        ]}
      />

      <AgnesCard>
        <AgnesCardContent>
          <AgnesTabs className={'w-full'} value={tab} onValueChange={setTab}>
            <AgnesTabsList>
              <AgnesTabsTrigger value="graficos">Gráficos</AgnesTabsTrigger>
              <AgnesTabsTrigger value="tabela">Tabela de Rubricas</AgnesTabsTrigger>
              <AgnesTabsTrigger value="lote">Análise em Lote</AgnesTabsTrigger>
            </AgnesTabsList>

            <AgnesTabsContent value="graficos">
              <TabGraficos />
            </AgnesTabsContent>

            <AgnesTabsContent value="tabela">
              <TabTabelaRubricas />
            </AgnesTabsContent>

            <AgnesTabsContent value="lote">
              <TabRubricasAnaliseLote refreshToken={rubricaLoteRefresh} />
            </AgnesTabsContent>
          </AgnesTabs>
        </AgnesCardContent>
      </AgnesCard>
    </>
  );
}
